export const SET_COMPANY_SCOPE = "SET_COMPANY_SCOPE"
export const INIT_COMPANY_SCOPE = "INIT_COMPANY_SCOPE"
